import { render } from "./Vuetable.vue?vue&type=template&id=d4d94d7a"
import script from "./Vuetable.vue?vue&type=script&lang=js"
export * from "./Vuetable.vue?vue&type=script&lang=js"

import "./Vuetable.vue?vue&type=style&index=0&id=d4d94d7a&lang=css"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__